/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Ingredient_Amount_PlaceholderInputs */

const en_editor_ingredient_amount_placeholder = /** @type {(inputs: Editor_Ingredient_Amount_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`200`)
};

const de_editor_ingredient_amount_placeholder = /** @type {(inputs: Editor_Ingredient_Amount_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`200`)
};

/**
* | output |
* | --- |
* | "200" |
*
* @param {Editor_Ingredient_Amount_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_ingredient_amount_placeholder = /** @type {((inputs?: Editor_Ingredient_Amount_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Ingredient_Amount_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_ingredient_amount_placeholder(inputs)
	return en_editor_ingredient_amount_placeholder(inputs)
});